import { isNonNullable } from '@ipfabric/utils/types';
import type { MutableRefObject, Ref, RefCallback } from 'react';

/**
 * Allow assigning one element into multiple refs
 *
 * Example:
 * ```
 * interface Props {
 *   innerRef?: React.Ref<HTMLDivElement>;
 * }
 * ...
 * const localRef = useRef<HTMLDivElement | null>(null);
 * <div ref={mergeRefs(localRef, props.innerRef)} />
 * ```
 */
export const mergeRefs =
  <T,>(...refs: (Ref<T> | undefined)[]): RefCallback<T> =>
  (value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (isNonNullable(ref)) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    }
  };
